import { pdfjs } from "react-pdf";

// Bundled from pdfjs-dist's own package rather than a CDN -- same-origin, no
// external script dependency to review/allowlist. Isolated into its own
// module because `import.meta.url` is webpack5 syntax that babel-jest's
// CommonJS transform can't parse -- Jest substitutes this whole module via
// jest.mock rather than ever parsing it (same reason react-to-pdf gets its
// own __mocks__ entry in package.json's jest config).
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();
